export const messages = {
  ru: {
    message: {
      hello: 'привет'
    }
  },
  kk: {
    message: {
      hello: 'салем'
    }
  }
}
